/** События аналитики: сессия и возвраты. */
import { z } from "zod";
import { Platform, PosInt, UInt } from "../common";
import { SessionId } from "./common";

export const sessionEvents = [
  /** Открытие игры (один раз за сессию). `startParam` — источник (`?startapp=`), без личных данных. */
  z.object({
    name: z.literal("app_open"),
    props: z.object({ platform: Platform, startParam: z.string().max(64).nullable() }),
  }),
  /** Началась сессия: `n` — номер за календарный день, `day` — дней с создания аккаунта. */
  z.object({ name: z.literal("session_start"), props: z.object({ sid: SessionId, n: PosInt, day: UInt }) }),
  /** Игра свёрнута или закрыта: `seconds` нарастает, длина сессии — максимум по `sid`. */
  z.object({
    name: z.literal("session_end"),
    props: z.object({ sid: SessionId, n: PosInt, seconds: UInt, waves: UInt }),
  }),
  /** Вернулся на следующий календарный день после первого входа. */
  z.object({ name: z.literal("return_day2"), props: z.object({ bestWave: UInt }) }),
] as const;
